var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.deleteConfirmDialog,
            callback: function($$v) {
              _vm.deleteConfirmDialog = $$v
            },
            expression: "deleteConfirmDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", [
                _vm._v(
                  "Are you sure you want to delete this " +
                    _vm._s(_vm.deleteName) +
                    " ?"
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius-color",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.$emit("delete")
                        }
                      }
                    },
                    [_vm._v("OK\n                ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f77a7a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f77a7a9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/DeleteConfirmDialog.vue
// module id = null
// module chunks = 